// src/components/shared/CameraError.tsx
import { Button } from '@/components/ui/button';
import { Callout } from '@/components/ui/callout';
import { useTranslation } from '@/hooks/useTranslation';

type CameraErrorProps = {
  message: string;
  onRetry?: () => void;
  className?: string;
};

/**
 * Camera-specific error display with retry functionality
 * Used when camera access fails or QR scanning encounters errors
 */
export function CameraError({ message, onRetry, className = '' }: CameraErrorProps) {
  const { t } = useTranslation();

  return (
    <div
      className={`absolute inset-0 bg-background/80 flex flex-col items-center justify-center text-center p-4 gap-4 ${className}`}
    >
      <Callout tone="error" className="max-w-md">
        {message}
      </Callout>
      {onRetry && (
        <Button type="button" className="min-w-[120px]" onClick={onRetry}>
          {t('camera.error.button')}
        </Button>
      )}
    </div>
  );
}
